import { Button } from '@listening/frontend/components/radix/button';
import { cn } from '@listening/utils/react-helpers';
import type { ReactNode } from 'react';
import { Spinner } from '@/components/shared-ui/spinner';

export function AuthPrimaryButton({
  isPending = false,
  disabled = false,
  asChild = false,
  children,
}: {
  isPending?: boolean;
  disabled?: boolean;
  asChild?: boolean;
  children: ReactNode;
}) {
  return (
    <div className='relative w-full'>
      <div
        className={cn(
          'relative overflow-hidden rounded-full p-[3px]',
          (isPending || disabled) && 'opacity-50',
        )}
      >
        <div
          aria-hidden='true'
          className='animate-border-shine absolute inset-[-3px] rounded-full bg-[200%_auto]'
          style={{
            backgroundImage: `linear-gradient(
              to right,
              #EC0C92 0%,
              #1820D9 25%,
              #1C92FF 50%,
              #00FFE0 75%,
              #EC0C92 100%
            )`,
          }}
        />
        <Button
          asChild={asChild}
          className={cn(
            'relative flex h-[52px] w-full gap-2 rounded-full bg-royal-50 px-8 py-5 font-jakarta text-xl leading-5 font-light text-white hover:bg-royal-50/80 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:outline-hidden sm:py-7',
            isPending ? 'cursor-wait' : 'cursor-pointer',
          )}
          disabled={isPending || disabled}
          size='lg'
          type={asChild ? undefined : 'submit'}
        >
          {asChild ? (
            children
          ) : (
            <>
              {isPending && <Spinner />}
              {children}
            </>
          )}
        </Button>
      </div>
    </div>
  );
}
